import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const analyticsId = process.env.REACT_APP_GA_ID;

declare global {
  interface Window {
    dataLayer?: unknown[];
    gtag?: (...args: unknown[]) => void;
    __GA4_INITIALIZED__?: boolean;
  }
}

const GoogleTracking: React.FC = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    if (!analyticsId) return;

    window.dataLayer = window.dataLayer || [];
    // gtag.js only processes `arguments` objects pushed to dataLayer, not plain arrays,
    // so this must be a regular function (not an arrow with rest params).
    window.gtag =
      window.gtag ||
      function gtag() {
        // eslint-disable-next-line prefer-rest-params
        window.dataLayer?.push(arguments);
      };

    if (!document.querySelector("script[data-google-analytics]")) {
      const script = document.createElement("script");
      script.async = true;
      script.dataset.googleAnalytics = "true";
      script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(analyticsId)}`;
      document.head.appendChild(script);
    }

    if (!window.__GA4_INITIALIZED__) {
      window.gtag("js", new Date());
      window.gtag("config", analyticsId, { send_page_view: false });
      window.__GA4_INITIALIZED__ = true;
    }
  }, []);

  useEffect(() => {
    if (!analyticsId) return;

    window.gtag?.("event", "page_view", {
      page_path: pathname,
      page_title: document.title,
    });
  }, [pathname]);

  return null;
};

export default GoogleTracking;
